<template lang="pug">
    .v-container
        v-card
            form(@submit.prevent="changePassword()")
                span.card-title {{ $vuetify.t('$vuetify.pages.Reset.title') }}
                v-text-field(
                    :label="$vuetify.t('$vuetify.pages.Reset.labels.newPassword') + ' *'"
                    type="password"
                    class="change-pass"
                    v-model="password"
                    :error-messages="getValidateMessage('Register', 'user.password', 'password')"
                )
                v-text-field(
                    :label="$vuetify.t('$vuetify.pages.Reset.labels.confirmPassword') + ' *'"
                    type="password"
                    v-model="confirmPassword"
                    class="confirmPassword"
                    :error-messages="getValidateMessage('Register', 'user.confirmPassword', 'confirmPassword')"
                )
                v-btn.button-fill(color="primary" type="submit" class="v-button black-button") {{ $vuetify.t('$vuetify.buttons.change') }}
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'

export default {
    mixins: [validationMixin, validate],
    data() {
        return {
            password: null,
            confirmPassword: null
        }
    },
    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        confirmPassword: {
            required,
            equal: function() {
                return this.password == this.confirmPassword
            }
        }
    },
    methods: {
        changePassword() {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                this.$store.dispatch('resetPassword', {
                    password: this.password,
                    token: this.$route.params.token
                })
                this.password = null
                this.confirmPassword = null
            }
        }
    }
}

</script>

<style lang="scss" scoped>
    .v-card {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 500px;
        width: 100%;
        padding: 20px;
    }

    .change-pass {
        margin-bottom: 10px;
    }

    .card-title {
        display: block;
        text-align: center;
        font-size: 26px;
        margin-bottom: 30px;
    }

    .button-fill {
        margin: 10px auto 0 auto;
        max-width: 100% !important;
    }
</style>
